import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import { ReactComponent as StarIcon } from "Assets/Icons/Curriculum/StarIcon.svg";

const ResearchPaperDetail = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog fullWidth maxWidth={"md"} open={open} onClose={handleClose}>
      <DialogTitle>
        <Box
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
        >
          Review Research Papers And Take A Step Forward At Earning Credits{" "}
          <Typography variant="body2">
            Reading Module Research Paper contributes to your coursework
            required to earn credits.
          </Typography>
          <Box
            sx={(theme) => ({
              border: `1px solid ${theme.palette.white.main}`,
              padding: "8px",
              borderRadius: "8px",
              marginTop: "8px",
            })}
          >
            <Typography
              display={"flex"}
              alignItems={"center"}
              gap="8px"
              variant="body2"
            >
              <PrimaryIcon
                icon={AlertIcon}
                height="16px"
                width="16px"
                color="white"
              />{" "}
              Research Paper remaining to read:2
            </Typography>
          </Box>
        </Box>
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Box
          sx={(theme) => ({
            border: `1px solid ${theme.palette.border.grey}`,
            "&>div": {
              borderBottom: `1px solid ${theme.palette.border.grey}`,
              "&:last-child": {
                borderBottom: "none",
              },
            },
          })}
        >
          {[...Array(2)]?.map((item, i) => {
            return (
              <Box
                key={i}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                padding="8px 16px"
              >
                <Typography color="secondary.light">
                  Big Data Analytics in Weather Forecasting
                </Typography>
                <Box display={"flex"} gap="10px" alignItems={"center"}>
                  <Chip
                    variant="filled"
                    filled
                    color="yellow"
                    label={
                      <Box display={"flex"} alignItems={"center"} gap={"6px"}>
                        <PrimaryIcon
                          height="18px"
                          width="18px"
                          icon={AlertIcon}
                        />{" "}
                        <Typography>Hey</Typography>
                      </Box>
                    }
                  />
                  <Link
                    href="#"
                    variant="subtitle"
                    fontWeight={500}
                    underline="none"
                  >
                    View Paper
                  </Link>
                </Box>
              </Box>
            );
          })}
        </Box>
        <Typography variant="subtitle" fontWeight={500}>
          How it works?
        </Typography>
        <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
          {[
            "Open the research paper.",
            "Spend time reading the entire paper page by page.Failing to do so will result in not receiving credit for this module.",
            "After completing your reading, please allow 3-4 hours for the research paper status to be updated by WOOLF University.",
          ]?.map((item, i) => {
            return (
              <Box
                key={i}
                sx={(theme) => ({
                  padding: "8px",
                  border: `1px solid ${theme.palette.border.blue}`,
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                })}
              >
                <PrimaryIcon
                  icon={StarIcon}
                  color="primary"
                  width="24px"
                  height="24px"
                />
                <Typography>{item}</Typography>
              </Box>
            );
          })}
        </Box>
        <Button sx={{ width: "fit-content" }} variant="contained">
          Fetch Latest Status
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ResearchPaperDetail;
